import { DatePicker, Stack } from '@fox/atoms';
import { Moment } from 'moment';
import { useCallback, useState } from 'react';
import { styled } from 'styled-components';
import { useActionCentreContext, useFilterClearListener } from '../action-centre-context';
import { ActionCentreColumn } from '../contracts';
import { Range } from './contracts';

const DateLabelColor = styled.div`
	label {
		color: ${props => props.theme.palette.text.disabled};
	}
`;

export function DateRangeFilter({ column, align }: { column: ActionCentreColumn; align?: 'row' | 'column' }) {
	const { setFilter } = useActionCentreContext();
	const [localFromDate, setLocalFromDate] = useState<Moment | null>(null);
	const [localToDate, setLocalToDate] = useState<Moment | null>(null);

	// Listen for filter clear events and reset local state
	useFilterClearListener(
		useCallback(() => {
			setLocalFromDate(null);
			setLocalToDate(null);
		}, [])
	);

	const updateFilter = useCallback(
		(fromDate: Moment | null, toDate: Moment | null) => {
			let range: Range | undefined = undefined;

			if ((fromDate && fromDate.isValid()) || (toDate && toDate.isValid())) {
				range = {};
				if (fromDate && fromDate.isValid()) range.gte = fromDate.toISOString();
				if (toDate && toDate.isValid()) range.lte = toDate.toISOString();
			}

			setFilter(range ? JSON.stringify(range) : undefined, column);
		},
		[setFilter, column]
	);

	const handleFromDateChange = useCallback(
		(date: Moment | null) => {
			setLocalFromDate(date);
			updateFilter(date, localToDate);
		},
		[updateFilter, localToDate]
	);

	const handleToDateChange = useCallback(
		(date: Moment | null) => {
			setLocalToDate(date);
			updateFilter(localFromDate, date);
		},
		[updateFilter, localFromDate]
	);

	return (
		<DateLabelColor>
			<Stack direction={align} spacing={2}>
				<DatePicker fullWidth value={localFromDate} label={`${column.title} (from)`} onChange={handleFromDateChange} size="small" />
				<DatePicker fullWidth value={localToDate} label={`${column.title} (to)`} onChange={handleToDateChange} size="small" />
			</Stack>
		</DateLabelColor>
	);
}
